// import React, {Component} from "react";
import { Tab, TabPanel, Tabs, TabList } from "react-web-tabs";
// import ReactDOM from "react-dom";
import "react-web-tabs/dist/react-web-tabs.css";
import config from 'react-global-configuration';
import {Link} from "react-router-dom";
import {Nav, Navbar, NavItem} from "react-bootstrap";

import React, {Component, useState} from 'react';
import axios from "axios";
import $ from 'jquery';
import {Button, Collapse, Input, Label, Modal, ModalBody, ModalFooter, Card, CardBody, CardText} from 'reactstrap';
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Select from 'react-select';
import Switch from 'react-switch';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
//import {confirmAlert} from 'react-confirm-alert';
import ReactTooltip from 'react-tooltip';
import jwt_decode from "jwt-decode";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SimpleReactValidator from 'simple-react-validator';
import AsyncPaginate, {reduceGroupedOptions} from 'react-select-async-paginate';
import moment from 'moment';
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import {List} from "react-virtualized";

import CommonNavbar, {navbar} from "./commonNavbar";


const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;


class AdminEditPromotion extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activer: [],
            isEMI: [],
            isUpfront: [],
            zeroCost: [],
            _notificationSystem: null,
            mapField: false,
            bank_name_list: ["AMEX BANK", "AXIS BANK", "CITIBANK", "HDFC Bank", "HSBC Bank", "ICICI Bank", "INDUSIND BANK", "KOTAK BANK", "RBL BANK", "SBI CARD", "STANDARD CHARTERED BANK", "YES BANK"],
            tenure_list: {
                '0': true,
                '1': true,
                '2': true,
                '3': true
            },
            bankOptions: [
                { name: 'AMEX', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'Axis', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'Citi', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'HDFC', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'HSBC', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'ICICI', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'IndusInd', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'Kotak', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'RBL', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'SBI', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'SCB', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true},
                { name: 'YES', M3: true, M6: true, M9: true, M12: true, M18: true, M24: true}
            ],
            brandSubventionOptions: [
                { value: 'Percent', label: 'Percent' },
                { value: 'Cashback', label: 'Flat Cashback' }
            ],
            bankSubventionOptions: [
                { value: 'NA', label: 'NA'  },
                { value: 'Percent', label: 'Percent' },
                { value: 'Cashback', label: 'Flat Cashback' }
            ],
            merchantSubventionOptions: [
                { value: 'All_Level', label: 'Applicable Everywhere'},
                { value: 'State_Level', label: 'State Level'},
                { value: 'City_Level', label: 'City Level'},
                { value: 'Merchant_Level', label: 'Merchant Level'},
                { value: 'Chain_Level', label: 'Chain Level' },
                { value: 'Store_Level', label: 'Store Level' },
            ],
            maxTxnAmount: 10000,
            selectedBrandSubvention: 'Percent',
            selectedBankSubvention: 'NA',
            selectedMerchantSubvention: 'All_Level',
            selectedState: [],
            selectedCity: [],
            merchant_disabler: true,
            //brand_subvention_list: ['Percent', 'Percent', 'Percent', 'Percent', 'Percent', 'Percent', 'Percent', 'Percent', 'Percent', 'Percent', 'Percent', 'Percent'],
            //bank_subvention_list: ['NA', 'NA', 'NA', 'NA', 'NA', 'NA', 'NA', 'NA', 'NA', 'NA', 'NA', 'NA'],
            brand_subvention_list:{},
            bank_subvention_list: [],
            brand_subvention_value: {},
            bank_subvention_value: [],
            maximum_cashback: [],
            disabler_list: [true, true, true, true, true, true, true, true, true, true, true, true],
            mapField2: false,
            startDate: moment(new Date()).format('YYYY-MM-DD'),
            endDate: moment(new Date()).format('YYYY-MM-DD'),
            sku_showModel: false,
            sku_list: [],
            raw_display_data: [],
            state_display_data: [],
            city_display_data: [],
            merchant_display_data: [],
            chain_display_data: [],
            store_display_data: [],
            state_data: [
                {value: "NA", label: "NA"}
            ],
            city_data: [
                {value: "NA", label: "NA"}
            ],
            state_loaded: false,
            city_loaded: false,
            sku_monitor: 0,
            selectedMerchValues: [],
            selectedRefineSubvention: [],
            slicedMerchValues: [],
            the_bank_list: {},
            bank_name_list1: {},
            refineSearch: false,
            state_ida: '',
            city_ida: '',
            merchant_ida: '',
            chain_ida: '',
            refinerMerch: [false, false, false, false, false],
            valuera: null,
            mapField3: false,
            mapField0: false,
            brand_has_merchant: [],
            stepper: [false, true, true, true],
            current_tab: 'vertical-tab-one',
            campaign_name: '',
            campaign_desc: '',
            merchant_length: null,
            merchant_counter: 1,
            merchant_counter_array: [0],
            follower: false,
            scheme_id: 0,
            scheme_display_data: [],
            sku_display_data: [],
            campaign_display_data: [],
            scheme_active: 0,
            a_m3 : {
                '0': true,
                '1': true,
                '2': true,
                '3': true,
                '4': true,
                '5': true,
                '6': true,
                '7': true,
                '8': true,
                '9': true,
                '10': true,
                '11': true
            },
            a_m6 : {
                '0': true,
                '1': true,
                '2': true,
                '3': true,
                '4': true,
                '5': true,
                '6': true,
                '7': true,
                '8': true,
                '9': true,
                '10': true,
                '11': true
            },
            a_m9 : {
                '0': true,
                '1': true,
                '2': true,
                '3': true,
                '4': true,
                '5': true,
                '6': true,
                '7': true,
                '8': true,
                '9': true,
                '10': true,
                '11': true
            },
            a_m12 : {
                '0': true,
                '1': true,
                '2': true,
                '3': true,
                '4': true,
                '5': true,
                '6': true,
                '7': true,
                '8': true,
                '9': true,
                '10': true,
                '11': true
            },
            a_m18 : {
                '0': true,
                '1': true,
                '2': true,
                '3': true,
                '4': true,
                '5': true,
                '6': true,
                '7': true,
                '8': true,
                '9': true,
                '10': true,
                '11': true
            },
            a_m24 : {
                '0': true,
                '1': true,
                '2': true,
                '3': true,
                '4': true,
                '5': true,
                '6': true,
                '7': true,
                '8': true,
                '9': true,
                '10': true,
                '11': true
            },
            merchant_file_uploaded: null,
            scheme_mapping_uploaded: null,
            is_download2: false,
            scheme_master_list:[],
            scheme_master_data: [],
            merchant_master_data: [],
            activer7: [],
            merchant2_display_data: [],
            merchant_master_list: [],
            party_id_mapper: [],
            party_master_id: null,
            scheme_monitor: 0,
            merchant_monitor: 0,
            sku_list1: [],
            scheme_activer: [],
            merchant_activer: [],
            end_date_tracker: 0,
            emiMenus:[],
            brand_user_id: null,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:[],
            chainValue:[],
            storeList:[],
            storeValue: [],
            freeemi_wallet: false

            //redirect = false
        };
        this.myRef = React.createRef();
        this.myRef2 = React.createRef();
    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    changeTenure(index, month, checked) {
        const bankOptions = this.state.bankOptions.map((bank_value, bank_index) => {
            if (index === bank_index) {
                return {
                    ...bank_value,
                    [month]: checked.target.checked
                };
            }
            return bank_value;
        });
        this.setState({bankOptions, mapField2: false});
    }

    onChangera(){
        console.log("Hello");
    }



    changeValue(index, value, checked) {
        const bankOptions = this.state.bankOptions.map((bank_value, bank_index) => {
            if (index === bank_index) {
                if(value === 'bank_type' && checked.value === 'NA'){
                    this.setState({
                        disabler_list: {...this.state.disabler_list, [index]:true}
                    });
                    return {
                        ...bank_value,
                        [value]: checked.value,
                        ['bank_value']: 0
                    };
                }
                else if(value === 'bank_type' && checked.value !== 'NA'){
                    this.setState({
                        disabler_list: {...this.state.disabler_list, [index]:false}
                    });
                    return {
                        ...bank_value,
                        [value]: checked.value
                    };
                }
                else{
                    return {
                        ...bank_value,
                        [value]: checked.value
                    };
                }
            }
            return bank_value;
        });
        this.setState({bankOptions});
    }

    downloadCSV = (file_id) => {
        this.setState({
            is_download:false
        });
        let xhr = $.ajax({
            url: "/brandemi/download_merchant_master_csv?file_id=" + file_id,
            type: 'GET',
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "application/csv"
                });
                let fileName = xhr.getResponseHeader('Content-Disposition').split("=")[1];
                //alert(fileName);
                let rfile = fileName.replace(/\"/g, "");
                console.log(fileName);
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true
                })
            }.bind(this)
        });
        this.setState({
            xhr:xhr
        })
    };

    downloadSchemeCSV = (file_id) => {
        this.setState({
            is_download2:false
        });
        let xhr = $.ajax({
            url: "/brandemi/download_scheme_mapping_csv?file_id=" + file_id,
            type: 'GET',
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "application/csv"
                });
                let fileName = xhr.getResponseHeader('Content-Disposition').split("=")[1];
                //alert(fileName);
                let rfile = fileName.replace(/\"/g, "");
                console.log(fileName);
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                window.URL.revokeObjectURL(url);
                this.setState({
                    is_download2: true
                })
            }.bind(this)
        });
        this.setState({
            xhr:xhr
        })
    };

    fileUploadHandler = () => {
        const timer1 = (Date.now()).toString();
        //console.log(timer1);
        this.setState({
            timer: timer1,
            isSubmit: true,
            loading: true,
            current_tab: 'vertical-tab-four',
            stepper: {...this.state.stepper, [3]:false}
        });
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data = new FormData();
        let random_string = timer1 + '_' + decoded._id + '_';
        data.append('file', this.state.selectedFile);
        data.append('fileType', this.state.fileType);
        data.append('userID', decoded._id);
        data.append('timer', this.state.timer);
        data.append('timer1', timer1);
        data.append('random_string', random_string);
        // let random_string = Date.now()+'_'+req.body.userID+'_';
        data.append('userGroup', decoded.userGroup);
        if(this.state.selectedFile == null){
            this.handleNotificationClick("tr", 3, "Please upload valid file");
            this.setState({
                isSubmit: false,
                loading: false
            });
        }
        else{
            var file = this.state.selectedFile;
            var ext = this.getFileExtension(file.name);
            console.log(file.name);
            console.log(ext);
            if (ext === 'csv') {
                axios.post(config.get('API_URL') + "/brandemi/upload_merchant_master/", data, {
                    headers: {
                        Authorization: ` ${localStorage.usertoken}`
                    }
                })
                    .then(res => {
                        console.log(res);
                        this.setState({
                            isSubmit: false,
                            loading: false,
                            notify: res.data.notify,
                            merchant_file_name: random_string + file.name,
                            merchant3_data: res.data,
                            file_name: file.name
                        });
                        //console.log(res.data.notify);
                        //console.log(res.data.inconsistent);
                        if (res.data.success !== undefined && res.data.notify !== undefined && res.data.inconsistent === 0) {

                            if (res.data.notify === 1){
                                this.handleNotificationClick("tr", 2, "File with same name uploaded. If you continue, old file will be overwritten.");
                            }

                            else{
                                this.handleNotificationClick("tr", 1, res.data.success);
                            }

                            // this.setState({
                            //     isSubmit: false,
                            //     loading: false,
                            //     notify: res.data.notify,
                            //     merchant_file_name: random_string + file.name,
                            //     merchant3_data: res.data
                            // });
                            console.log(res.data);
                            this.openSectionToMap(true);
                        }

                        else {
                            if (res.data.inconsistent === 1){
                                this.handleNotificationClick("tr", 3, "There are inconsistencies");
                            }
                            else{
                                this.handleNotificationClick("tr", 3, res.data.error);
                            }
                            this.setState({
                                isSubmit: false,
                                loading: false
                            });
                        }
                    })
                    .catch(err => { // then print response status
                        this.handleNotificationClick("tr", 3, "Something Wrong!");
                        this.setState({
                            isSubmit: false,
                            loading: false
                        });
                        // this.openSectionToMap(true); // remove and place in success block
                    })
            }
            else {
                this.handleNotificationClick("tr", 3, "Please upload valid file");
                this.setState({
                    isSubmit: false,
                    loading: false
                });
            }
        }
    };

    retrieveStateData(){
        console.log("retrieving state data");
        axios.get(config.get('API_URL') + '/brandemi/get_state',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            const state_data = response.data.map((values, index) =>{
                console.log(values['state_name']);
                return{
                    ['value']: values['state_id'],
                    ['label']: values['state_name']
                };
            });
            this.setState({
                state_data: state_data,
                mapField2: false,
                state_display_data: response.data,
                loading: false
            });
        });
    }

    retrieveCityData(){
        console.log("retrieving city data");
        axios.get(config.get('API_URL') + '/brandemi/get_city',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            const city_data = response.data.map((values, index) =>{
                if (index == 0) {
                    this.setState({selectedCity: values['city_name']});
                }
                console.log(values['city_name']);
                return{
                    ['value']: values['city_id'],
                    ['label']: values['city_name']
                };
            });
            this.setState({city_data: city_data, mapField2: false});
            this.setState({
                city_display_data: response.data
            });
            this.setState({
                loading: false
            });
        });
    }

    componentDidMount(){
        this.setState({
            scheme_id: this.props.match.params.id,
            _notificationSystem: this.refs.notificationSystem
        })
        this._getCampaignData();
        this._getAllMerchants1();

        //var _notificationSystem = this.refs.notificationSystem;
        this.validator = new SimpleReactValidator();
    }

    // componentWillMount(){
    //     this.generateBankList();
    // }


    getSchemeMasterDataView(){
        if ($.fn.DataTable.isDataTable('#brandSchemeMasterViewTable')) {
            $('#brandSchemeMasterViewTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_new_schemes_master1', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: this.state.party_master_id
            }
        }).then(response => {
            //console.log(response);
            const resultObject = {};
            const resultObject2 = {};
            response.data.map((value, index) => {
                resultObject[value.id] = true;
//                 this.setState({
//                     scheme_activer: {...this.state.scheme_activer, [value.id]:true }
//                 });
                let status = false;
                if(value.active_status===1) { status = true;}
                resultObject2[index] = status;
//                 this.setState({
//                     activer: {...this.state.activer, [index]:status }
//                 });
            });
            this.setState({
                scheme_master_data: response.data,
                scheme_activer: resultObject,
                activer: resultObject2
            });
            $('#brandSchemeMasterViewTable').DataTable();
        });
        return null;
    }


    // getMerchantMasterDataView(){
    //     if ($.fn.DataTable.isDataTable('#brandSchemeMasterViewTable')) {
    //         $('#brandSchemeMasterViewTable').DataTable().destroy();
    //     }
    //     const token = localStorage.usertoken;
    //     const decoded = jwt_decode(token);
    //     axios.get(config.get('API_URL') + '/brandemi/get_merchant_master_data', {
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         },
    //         params: {
    //             campaign_id: this.props.match.params.id
    //         }
    //     }).then(response => {
    //         console.log(response);
    //         response.data.map((value, index) => {
    //             let status = false;
    //             if(value.active_status===1) { status = true;}
    //             this.setState({
    //                 activer7: {...this.state.activer, [index]:status }
    //             });
    //         });
    //         this.setState({
    //             merchant_master_data: response.data
    //         });
    //         $('#brandSchemeMasterViewTable').DataTable();
    //     });
    //     return null;
    // }

    getMerchantMappingData(){
        if(this.state.party_master_id != null){
            if ($.fn.DataTable.isDataTable('#brandMerchantMasterViewTable')) {
                $('#brandMerchantMasterViewTable').DataTable().destroy();
            }
            const token = localStorage.usertoken;
            const decoded = jwt_decode(token);
            axios.get(config.get('API_URL') + '/brandemi/view_merchant_maintainer',{
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
                params: {
                    party_master_id: this.state.party_master_id
                }
            }).then(response => {
                //console.log("mmm",response.data);
                const resultObject = {};
                for (let i = 0, len = response.data.length; i < len; i++) {
                  const item = response.data[i];
                  resultObject[item.id] = true;
                }
//                 response.data.map((value, index) => {
//                     this.setState({
//                         merchant_activer: {...this.state.merchant_activer, [value.id]: true}
//                     })
//                 })
                this.setState({
                    merchant2_display_data: response.data,
                    merchant_activer: resultObject
                });
                $('#brandMerchantMasterViewTable').DataTable();
                this.setState({
                    loading: false,
                    user_id: decoded._id
                });
            });
        }
    }

    getPartyID(){
        if ($.fn.DataTable.isDataTable('#party_showTable')) {
            $('#party_showTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_id: decoded._id,
            }
        }).then(response => {
            //console.log(response.data);
            response.data.map((values, index) => {
                console.log(values.party_id);
                this.setState({
                    party_master_id: values.party_id
                })
            })
            this.setState({
                party_id_mapper: response.data
            });
            $('#party_showTable').DataTable();
            this.setState({
                loading: false,
                user_id: decoded._id
            });
            this._refreshSku_Show_View();
            //this.brand_has_merchant_finder();
            this._getSchemeData();
            this._getSkuData();
            this._getSchemeDetails();
            this._getCampaignData();
            this._getMerchantFileUploaded();
            this._getSchemeMappingUploaded();
            this.getSchemeMasterDataView();
            //this.getMerchantMasterDataView();
            this._getMerchantDetails();
            this.getMerchantMappingData();
        });

    }


    _getSchemeDetails(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.post(config.get('API_URL') + '/brandemi/view_brand_schemes_promotion1',
        {
                promotion_id: this.props.match.params.id
        },
        {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            //console.log(response.data);
            //console.log("gggggggggg", response);
            const resultObject = {};
             const selected_scheme = []
            response.data.map((values, index) => {
                resultObject[values.id] = true;
                selected_scheme.push({"label":values.schemeName, "value":values.id})
//                 this.setState({
//                     scheme_master_list: {...this.state.scheme_master_list, [values.scheme_id]: true}
//                 })
            })
            this.setState({
                scheme_monitor: response.data.length,
                scheme_master_list: resultObject,
                selected_scheme: selected_scheme
            })
            console.log("DOne");
        });
    }

    _getAllMerchants(){
        axios.post(config.get('API_URL')+'/brandemi/get-merchant',{},{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            console.log(response.data);
            if(Array.isArray(response.data) && response.data.length) {

                response.data.map((merchant, index) => {
                    this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
            }
        });
    }

    _getAllMerchants1(){
        axios.post(config.get('API_URL')+'/brandemi/get-merchant',{},{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            //console.log(response.data);
            if(Array.isArray(response.data) && response.data.length) {
                var mList = []
                response.data.map((merchant, index) => {
                    mList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
                this.setState({
                    merchantList:mList

                })
            }
            this.getMerchantData();
        });
    }

    getMerchantData(){
        axios.post(config.get('API_URL')+'/brandemi/get-promotion-merchant',{
            id: this.props.match.params.id
        },{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {

            if(Array.isArray(response.data) && response.data.length) {
                let value='';
                let midArray = [];
                let optionSelected = [];
                response.data.map((mids, i) => {
                    midArray.push(mids.merchant_code)
                    var index = this.state.merchantList.findIndex(obj => obj.value==mids.merchant_code);
                    this.state.merchantList.move(index,0).join(',');
                    optionSelected.push({value: mids.merchant_code, label: mids.merchant_name})
                });
                //console.log(midArray);
                //console.log(optionSelected);
                this.setState({
                    merchantID:midArray,
                    chainID:'',
                    merchantValue:optionSelected,
                    chainValue:[],
                    storeID:'',
                    storeValue: []
                }, () =>{
                    this.getChain1(midArray, 'merchant', this.state.object_type, this.state.object_code);
                    this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code);
                    // response.data.map((merchant, index) => {
                    //     this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                    // });
                });
            }
        });
    }

    getChainData(){
        axios.post(config.get('API_URL')+'/brandemi/get-promotion-chain',{
            id: this.props.match.params.id
        },{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            console.log(response.data);
            if(Array.isArray(response.data) && response.data.length) {
                let cidArray = [];
                let optionSelected = [];
                if(response.data[0]['chain_code'] == 9){
                    console.log("Yay");
                }
                else{
                    response.data.map((cids, i) => {
                        cidArray.push(cids.chain_code)
                        // var index = this.state.chainList.findIndex(obj => obj.value==cids.chain_code);
                        // this.state.chainList.move(index,0).join(',');
                        optionSelected.push({value: cids.chain_code, label: cids.chain_name})
                    });
                    this.setState({
                        chainID: cidArray,
                        //chainValue:optionSelected,
                        storeID:'',
                        storeValue: []
                    }, () => {
                        this.getStore1(cidArray, 'chain', this.state.object_type, this.state.merchantID);
                    });
                }
            }
        });
    }

    getStoreData(){
        axios.post(config.get('API_URL')+'/brandemi/get-promotion-store',{
            id: this.props.match.params.id
        },{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            console.log(response.data);
            if(Array.isArray(response.data) && response.data.length) {
                let value='';
                let sidArray = [];
                let optionSelected = [];
                console.log(response.data);
                if(response.data[0]['store_code'] == 9){
                    console.log("Yay");
                }
                else{
                    response.data.map((sids, i) => {
                        sidArray.push(sids.store_code)
                        // var index = this.state.storeList.findIndex(obj => obj.value==sids.store_code);
                        // this.state.storeList.move(index,0).join(',');
                        optionSelected.push({value: sids.store_code, label: sids.store_name, value1: sids.merchant_code, value2: sids.chain_code, merch_name: sids.merchant_name, chain_name: sids.chain_name});
                    });

                    this.setState({
                        storeID: sidArray,
                        storeValue:optionSelected
                    });
                }
            }
        });
    }

    changeMerchant1(optionSelected){
        console.log(optionSelected);
        let value='';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                var index = this.state.merchantList.findIndex(obj => obj.value==mids.value);
                this.state.merchantList.move(index,0).join(',');
            });
        }
        this.setState({
            merchantID:midArray,
            chainID:'',
            merchantValue:optionSelected,
            chainValue:[],
            storeID:'',
            storeValue: [],
            stepper: {...this.state.stepper, [4]: true},
            current_tab: 'vertical-tab-three'
        }, () =>{
            this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
            this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code);
        });
        //this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);

    }

    getChain(code, type, object_type, object_code){
        axios.post(config.get('API_URL')+'/brandemi/get-chain',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            console.log(response.data);
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name, value1: chain.merchant_code, merch_name: chain.merchant_name})
            });
            this.setState({
                chainList:chalinList
            })
        });
    }

    getChain1(code, type, object_type, object_code){
        axios.post(config.get('API_URL')+'/brandemi/get-chain',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            console.log(response.data);
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name, value1: chain.merchant_code, merch_name: chain.merchant_name})
            });
            this.setState({
                chainList:chalinList
            }, () =>{
                this.getChainData();
                //this.
            })
        });
    }

    changeChain(optionSelected) {
        let value='';
        let cidArray = [];
        if(optionSelected.length<1){
            value = null;
            cidArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                var index = this.state.chainList.findIndex(obj => obj.value==cids.value);
                this.state.chainList.move(index,0).join(',');
            });
        }

        this.setState({
            chainID: cidArray,
            chainValue:optionSelected,
            storeID:'',
            storeValue: [],
            stepper: {...this.state.stepper, [4]: true},
            current_tab: 'vertical-tab-three'
        });

        //this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);

        this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID);


    }

    getStore(code, type, object_type, object_code) {
        axios.post(config.get('API_URL')+'/brandemi/get-store', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            this.setState({storeID:''});
            console.log(response.data);
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name, value1:store.merchant_code, value2: store.chain_code, chain_name: store.chain_name, merch_name: store.merchant_name})
            });
            this.setState({
                storeList:storeList
            })
        });
    }


    getStore1(code, type, object_type, object_code) {
        axios.post(config.get('API_URL')+'/brandemi/get-store', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            this.setState({storeID:''});
            console.log(response.data);
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name, value1:store.merchant_code, value2: store.chain_code, chain_name: store.chain_name, merch_name: store.merchant_name})
            });
            this.setState({
                storeList:storeList
            }, () =>{
                this.getStoreData();
            })
        });
    }

    changeStore(optionSelected) {
        let value='';
        let sidArray = [];
        if(optionSelected.length<1){
            value = null;
            sidArray = '';
        }
        else{
            optionSelected.map((sids, i) => {
                sidArray.push(sids.value)
                var index = this.state.storeList.findIndex(obj => obj.value==sids.value);
                this.state.storeList.move(index,0).join(',');
            });
        }
        this.setState({
            storeID: sidArray,
            storeValue:optionSelected,
            stepper: {...this.state.stepper, [4]: true},
            current_tab: 'vertical-tab-three'
        });
        //this.get_dash_details(this.state.dashId, '','', this.state.yestSend, this.state.todSend);
        // this._get_filtered_emi_scheme_report(this.state.merchantID, this.state.chainID, sidArray, this.state.acqBankIds, this.state.cityIds,this.state.frequency,
        //     this.state.yestSend, this.state.todSend);
    }

    _findBrandUserID(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_brand_user_id',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                id: this.props.match.params.id,
            }
        }).then(response => {
            //console.log(response.data);
            //console.log(response);
//             response.data.map((values, index) => {
//                 console.log(values.user_id);
//                 this.setState({
//                     brand_user_id: values.user_id
//                 })
//             })
            this.setState({
               brand_user_id: response.data[0].user_id
            })
            console.log("DOne");
        });
    }

    _getMerchantDetails(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_merchant_details',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                id: this.props.match.params.id,
            }
        }).then(response => {
            //console.log(response.data);
            //console.log(response);
            const resultObject = {};
            response.data.map((values, index) => {
                resultObject[values.merchant_data_id] = true;
//                 this.setState({
//                     merchant_master_list: {...this.state.merchant_master_list, [values.merchant_data_id]: true}
//                 })
            })
            this.setState({
                merchant_monitor: response.data.length,
                merchant_master_list: resultObject
            })
            console.log("DOne");
        });
    }


    _getMerchantFileUploaded(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_merchant_master',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                id: this.props.match.params.id,
            }
        }).then(response => {
            //console.log(response.data);
            console.log(response);
            response.data.map((values, index) => {
                this.setState({
                    merchant_file_uploaded: values.stored_file_name
                })
            })
            console.log("DOne");
        });
    }

    _getSchemeMappingUploaded(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_scheme_mappings',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                id: this.props.match.params.id,
            }
        }).then(response => {
            //console.log(response.data);
            console.log(response);
            response.data.map((values, index) => {
                this.setState({
                    scheme_mapping_uploaded: values.stored_file_name
                })
            })
            console.log("Done");
        });
    }


    _getSchemeData(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_scheme_data',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                scheme_id: this.props.match.params.id,
            }
        }).then(response => {
            console.log("scdata",response.data);
            response.data.map((values, index) => {
                console.log(values);
                if (values.is_selected == 1){
                    let var1 = true;
                    let var2 = true;
                    let var3 = true;
                    let var4 = true;
                    let var5 = true;
                    let var6 = true;
                    let var7 = true;
                    let var8 = true;
                    let var9 = true;
                    let var10 = true;
                    if(values.is_emi == 0){
                        var2 = false;
                    }
                    else{
                        if (values.m3 == 0)
                        {
                            this.state.a_m3[index] = false;
                        }
                        if (values.m6 == 0)
                        {
                            this.state.a_m6[index] = false;
                        }
                        if (values.m9 == 0)
                        {
                            this.state.a_m9[index] = false;
                        }
                        if (values.m12 == 0)
                        {
                            this.state.a_m12[index] = false;
                        }
                        if (values.m18 == 0)
                        {
                            this.state.a_m18[index] = false;
                        }
                        if (values.m24 == 0)
                        {
                            this.state.a_m24[index] = false;
                        }
                    }
                    if(values.is_zero_cost == 0){
                        var3 = false;
                    }
                    if(values.is_upfront == 0){
                        var4 = false;
                    }
                    // let m3 = this.state.bankOptions[index].M3;
                    // m3 = var5;
                    // let m6 = this.state.bankOptions[index].M6;
                    // m6 = var6;
                    // let m9 = this.state.bankOptions[index].M9;
                    // m9 = var7;
                    // let m12 = this.state.bankOptions[index].M12;
                    // m12 = var8;
                    // let m18 = this.state.bankOptions[index].M18;
                    // m18 = var9;
                    // let m24 = this.state.bankOptions[index].M24;
                    // m24 = var10;
                    this.setState({
                        activer: {...this.state.activer, [index]:true},
                        isEMI: {...this.state.isEMI, [index]:var2},
                        zeroCost: {...this.state.zeroCost, [index]:var3},
                        isUpfront: {...this.state.isUpfront, [index]:var4},

                    })
                    const bankOptions = this.state.bankOptions.map((bank_value, bank_index) => {
                        if (index === bank_index) {
                            return {
                                ...bank_value,
                                ['M3']: this.state.a_m3[bank_index],
                                ['M6']: this.state.a_m6[bank_index],
                                ['M9']: this.state.a_m9[bank_index],
                                ['M12']: this.state.a_m12[bank_index],
                                ['M18']: this.state.a_m18[bank_index],
                                ['M24']: this.state.a_m24[bank_index]
                            };
                        }
                        return bank_value;
                    });
                    this.setState({bankOptions, mapField2: false});
                }
                else{
                    this.setState({
                        isEMI: {...this.state.isEMI, [index]:false},
                        zeroCost: {...this.state.zeroCost, [index]:false},
                        isUpfront: {...this.state.isUpfront, [index]:false}
                    })
                }
                this.setState({
                    maximum_cashback: {...this.state.maximum_cashback, [index]:values.cashback},
                    brand_subvention_list: {...this.state.brand_subvention_list, [index]:values.brand_sub},
                    brand_subvention_value: {...this.state.brand_subvention_value, [index]:values.brand_sub_amount},
                })
            })
            this.setState({
                scheme_display_data: response.data
            });
            console.log("DOne");
        });
    }

    _getSkuData(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.post(config.get('API_URL') + '/brandemi/scheme_sku_mapping_details',
        {
                promotion_id: this.props.match.params.id
        },
        {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            //console.log("sku_list",response);
            const resultObject = {};
            const selected_sku = []
            response.data.map((values, index) => {
                resultObject[values.brandSku] = true;
                selected_sku.push({"label":values.brandSku, value:values.brandSku})
//                 this.setState({
//                     sku_list: {...this.state.sku_list, [values.sku]:true}
//                 })
            })
            this.setState({
                sku_display_data: response.data,
                sku_monitor: response.data.length,
                sku_list: resultObject,
                selected_sku:selected_sku
            });
            console.log("DOne");
        });
    }

    _getCampaignData(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_campaign_data',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                id: this.props.match.params.id,
            }
        }).then(response => {
            //console.log(response.data);
            //console.log(response);
//             response.data.map((values, index) => {
//                 if(index == 0){
//                     let free_emi = false;
//                     if(values.freeemi == 1 || values.freeemi == '1'){
//                         free_emi = true;
//                     }
//                     this.setState({
//                         party_master_id: values.party_master_id,
//                         campaign_name: values.campaign_name,
//                         campaign_desc: values.campaign_desc,
//                         startDate: values.start_date,
//                         endDate: values.end_date,
//                         maxTxnAmount: values.max_cashback,
//                         scheme_active: values.active,
//                         reason: values.reason,
//                         freeemi_wallet: free_emi
//                     })
//                 }
//             })
            const values = response.data;
            let free_emi = false;
                    if(values.freeemi == 1 || values.freeemi == '1'){
                         free_emi = true;
                     }

            this.setState({
                        party_master_id: values.manufacturerCode,
                        campaign_name: values.promotionName,
                        campaign_desc: values.promotionDescription,
                        // startDate: values.promotionStartDate,
                        // endDate: values.promotionEndDate,
                        startDate: moment(values.promotionStartDate).format('YYYY-MM-DD'),
                        endDate: new Date(new Date(values.promotionEndDate).getTime() + 86400000).toISOString().split("T")[0],
                        maxTxnAmount: values.max_cashback,
                        scheme_active: values.active,
                        reason: values.reason,
                        freeemi_wallet: free_emi,
                        selected_emi_type_value: values.emi_type,
                        selected_emi_type_value_label: values.emi_type
                    })
            this.setState({
                campaign_display_data: response.data
            });
            console.log("DOne");
            this._refreshSku_Show_View();
            //this.getMerchantMappingData();
            this._findBrandUserID();
            //await this.brand_has_merchant_finder();
            //this._getSchemeData();
            this._getSkuData();
            //this._getMerchantFileUploaded();
            //this._getSchemeMappingUploaded();
            this._getSchemeDetails();
            this.getSchemeMasterDataView();
            //await this.getMerchantMasterDataView();
            ///this._getMerchantDetails();
        });
    }

    _refreshSku_Show_View() {
        if ($.fn.DataTable.isDataTable('#sku_showTable')) {
            $('#sku_showTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/view_brand_sku1',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: this.state.party_master_id
            }
        }).then(response => {
            //console.log(response.data);
//             response.data.map((values, index) => {
//                 this.setState({
//                     sku_list1: {...this.state.sku_list1, [values.sku]:true},
//                 })
//             })
            const resultObject = {};

            for (let i = 0, len = response.data.length; i < len; i++) {
              const item = response.data[i];
              resultObject[item.sku] = true;

            }
            this.setState({
                raw_display_data: response.data,
                sku_list1:resultObject
            });
            $('#sku_showTable').DataTable();
        });
    }

    // brand_has_merchant_finder(){
    //     const token = localStorage.usertoken;
    //     const decoded = jwt_decode(token);
    //     axios.get(config.get('API_URL') + '/brandemi/get_brand_has_merchant',{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         },
    //         params: {
    //             user_id: decoded._id
    //         }
    //     }).then(response => {
    //         console.log(response.data);
    //         //vary() {

    //         //}
    //         let vary1 = response.data.map((values, index) => {
    //             return{
    //                 ['value']: values['merchant_code'],
    //                 ['label']: values['merchant_name'],
    //                 ['value1']: values['merchant_id']
    //             };
    //         });
    //         console.log(response.data.length);
    //         // if (response.data.length > 0){
    //         //     let merchant_counter_array = this.state.merchant_counter_array.concat[0];
    //         //     this.setState({
    //         //         merchant_counter: 1,
    //         //         merchant_counter_array
    //         //     })
    //         // }
    //         this.setState({
    //             brand_has_merchant: vary1,
    //             merchant_length: response.data.length
    //         });
    //     })
    // }
    // generateBankList() {
    //     const token = localStorage.usertoken;
    //     const decoded = jwt_decode(token);
    //     axios.get(config.get('API_URL') + '/brandemi/get_bank_list',{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         }
    //     }).then(response => {
    //         console.log(response.data);
    //         response.data.map((value, index) => {
    //             if (value.issuer_bank_code != "ISB0000000004" || value.issuer_bank_display_name != "ISB0000000012" || value.issuer_bank_display_name != "XXXXXXXXXXXXX"){
    //                 this.setState({
    //                     bank_name_list1: {...this.state.bank_name_list1, [value.issuer_bank_code]:value.issuer_bank_display_name},
    //                 });
    //             }
    //         });
    //         this.setState({
    //             the_bank_list: response.data,
    //             loading: false
    //         });
    //     });
    // }

    // openSectionToSKU = (status) => {
    //     this.setState({
    //         mapField2: status
    //     })
    // };

    selectAll(){
        this.setState({
            sku_monitor: 0
        })
        this.state.raw_display_data.map((values, index) => {
//             console.log(values);
//             console.log(this.state.sku_list);
            this.setState({
                sku_list: this.state.sku_list1,
                sku_monitor: this.state.raw_display_data.length
            });
        })
    }

    deSelectAll(){
        this.setState({
            sku_list: [],
            sku_monitor: 0
        })
    }

    selectAllPromotions(){
        this.setState({
            scheme_master_list: this.state.scheme_activer,
            scheme_monitor: this.state.scheme_master_data.length
        })
    }

    deselectAllPromotions(){
        this.setState({
            scheme_master_list: [],
            scheme_monitor: 0
        })
    }

    selectAllMerchants(){
        this.setState({
            merchant_master_list: this.state.merchant_activer,
            merchant_monitor: this.state.merchant2_display_data.length
        })

    }

    deselectAllMerchants(){
        this.setState({
            merchant_master_list: [],
            merchant_monitor: 0
        })

    }

    openSectionToBanks = (status) => {
        if (this.state.sku_monitor === 0){
            this.handleNotificationClick("tr", 3, "Select atleast one SKU");
        }
        else{
            this.setState({
                mapField2: status,
                current_tab: 'vertical-tab-two',
                stepper: {...this.state.stepper, [1]:false},
            });
        }
    }


    sendEMIMappings(status){
        let value1 = this.validateValue();
        let value2 = this.validateDate();
        let value3 = this.validateTenure();
        console.log(value1);
        console.log(value2);
        console.log(value3);
        if(this.state.scheme_monitor === 0){
            this.handleNotificationClick("tr", 3, "Select atleast one scheme");
        }
        else{
            this.setState({
                mapField2: status,
                current_tab: 'vertical-tab-three',
                stepper: {...this.state.stepper, [2]:false},
            });
        }
    }

    merchantSubmitHandler(){
        if(this.state.merchantValue.length === 0){
            this.handleNotificationClick("tr", 3, "Select atleast one merchant");
        }
        else{
            this.setState({
                isSubmit: true,
                current_tab: 'vertical-tab-four',
                stepper: {...this.state.stepper, [3]:false}
            });
        }
    }

    openSectionToProduct = (status) => {
        let value2 = this.validateDate();
        if (this.state.sku_monitor === 0){
            this.handleNotificationClick("tr", 3, "Select atleast one SKU");
        }
        else if(this.state.scheme_monitor === 0){
            this.handleNotificationClick("tr", 3, "Select atleast one scheme");
        }
        else if(this.state.merchantValue.length === 0){
            this.handleNotificationClick("tr", 3, "Select atleast one merchant");
        }
        else if(this.state.campaign_name == null || this.state.campaign_name == '')
        {
            this.handleNotificationClick("tr", 3, "Please enter promotion name");
        }
        else if(this.state.campaign_desc == null || this.state.campaign_desc == '')
        {
            this.handleNotificationClick("tr", 3, "Please enter promotion description");
        }
        else if(value2 != 0){
            this.handleNotificationClick("tr", 3, "Please insert valid date range");
        }
        else if(((this.state.maxTxnAmount)*1) <= 0 || (this.state.maxTxnAmount === '')){
            this.handleNotificationClick("tr", 3, "Please insert value greater than 0");
        }
        else{
            this.setState({
                mapField0: status,
                newConfirmationModel: !this.state.newConfirmationModel
            });
        }

    }
    // openSectionToProduct = (status) => {
    //     this.setState({
    //         mapField0: status,
    //         newConfirmationModel: !this.state.newConfirmationModel
    //     });
    // }

    validateDate(){
        //console.log("hello");
        let start_date = moment(this.state.startDate).format('YYYY-MM-DD');
        let end_date = moment(this.state.endDate).format('YYYY-MM-DD');
        // console.log(this.state.endDate);
        if(start_date > end_date){
            //console.log("yay");
            this.handleNotificationClick("tr", 3, "Select valid date range");
            console.log("error");
            return 1;
        }
        else{
            return 0;
        }
    }

    validateTenure(){
        let returner = 0;
        let value1 = this.state.bank_name_list.map((value, index) => {
            if (this.state.bankOptions[index]["M3"] === false && this.state.bankOptions[index]["M6"] === false && this.state.bankOptions[index]["M9"] === false && this.state.bankOptions[index]["M12"] === false && this.state.bankOptions[index]["M18"] === false && this.state.bankOptions[index]["M24"] === false && this.state.isEMI[index] == true)
            {
                this.handleNotificationClick("tr", 3, "Select atleast one tenure at bank " + this.state.bankOptions[index]['name']);
                console.log("error");
                returner = 1;
            }
        });
        return returner;
        //console.log("yay");
    }

    validateValue(){
        let returner = 0;
        let value1 = this.state.bank_name_list.map((value, index) => {
            if ((this.state.brand_subvention_value[index])*1 < 0 || (this.state.brand_subvention_value[index] === '')){
                this.handleNotificationClick("tr", 3, "Enter positive value at brand subvention value of bank " + this.state.bankOptions[index]['name']);
                console.log("error");
                returner = 1;
            }
            else if ((this.state.bank_subvention_list[index] === 'Percent' || this.state.bank_subvention_list[index] === 'Cashback') && (this.state.bank_subvention_value[index])*1 < 0 || (this.state.bank_subvention_value[index] === ''))
            {
                this.handleNotificationClick("tr", 3, "Enter positive value at bank subvention value of bank " + this.state.bankOptions[index]['name']);
                console.log("error");
                returner = 1;
            }
            else if ((this.state.maximum_cashback[index])*1 < 0 || (this.state.maximum_cashback[index] === ''))
            {
                this.handleNotificationClick("tr", 3, "Enter positive value at maximum cashback value of bank " + this.state.bankOptions[index]['name']);
                console.log("error");
                returner = 1;
            }
        });
        if ((this.state.maxTxnAmount)*1 < 0 || (this.state.maxTxnAmount === '')){
            this.handleNotificationClick("tr", 3, "Enter positive value at maximum cashback allowed per card.");
            console.log("error");
            returner = 1;
        }
        return returner;
    }

    // sendEMIMappings(value){
    //     let value1 = this.validateValue();
    //     let value2 = this.validateDate();
    //     let value3 = this.validateTenure();
    //     console.log(value1);
    //     console.log(value2);
    //     console.log(value3);
    //     if(value1 === 0 && value2 === 0 && value3 === 0 && this.state.sku_monitor > 0){
    //         //this.openSectionToSKU(value);
    //         //this.toggleConfirmationModel();
    //         // if(this.myRef2.current){
    //         //     this.myRef2.current.scrollIntoView({
    //         //        behavior: "smooth",
    //         //        block: "nearest"
    //         //     });
    //         // }
    //         this.setState({
    //             mapField3: true,
    //             current_tab: 'vertical-tab-three',
    //             stepper: {...this.state.stepper, [2]:false}
    //         })
    //     }
    //     else{
    //         this.setState({
    //             mapField2: false
    //         });
    //     }

    //     //else{
    //     //    this.openSectionToSKU(value);
    //     //}
    // }

    merchantValidator(value) {
        this.setState({
            //newConfirmationModel: !this.state.newConfirmationModel
            current_tab: 'vertical-tab-four',
            stepper: {...this.state.stepper, [3]:false}
        });
    }

    multiSelectValidator(index){
        if (index === this.state.selectedMerchantSubvention){
            return true;
        }
        else{
            return false;
        }
    }

    refineEnabler(index){

    }

    onTurnRefine = (value) => {
        console.log("hi");
        this.setState({
            refineSearch: value
        })
        // if (value == false){
        //     let refinerMerch = [...this.state.refinerMerch];     // create the copy of state array
        //     refinerMerch[0] = false;
        //     refinerMerch[1] = false;
        //     refinerMerch[2] = false;
        //     refinerMerch[3] = false;
        //     refinerMerch[4] = false;
        //     this.setState({
        //         refinerMerch
        //     })
        // }
    }

    updateSKUVisiblity = (value) => {
        this.setState({
            mapField2: value
        })
    };

    updateFreeEmiWallet = (valuer) => {
        this.setState({
            freeemi_wallet: valuer.target.checked,
        });
    };

    updateBrandSubvention = (index, optionSelected) => {
        this.setState({
            brand_subvention_list: {...this.state.brand_subvention_list, [index]:optionSelected.value },
            mapField2: false
        })
    };

    updateState = (optionSelected) => {
        if (optionSelected != null){
            this.setState({
                selectedState: {...this.state.selectedState, [optionSelected.value]: optionSelected.value},
                mapField2: false
            })
        }
        else{
            this.setState({
                selectedState: [],
                mapField2: false
            })
        }
    };


    // _getStateList = async() => {
    //     const options = [];
    //     let res = await axios.get(config.get('API_URL') + "/brandemi/get_state_values", {
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         },
    //     });

    //     await res.data.map((str, index) => {
    //         options.push({
    //             value: str.state_id,
    //             label: str.state_name
    //         });
    //     })
    //     console.log(options)
    //     const sleep = ms =>
    //         new Promise(resolve => {
    //             setTimeout(() => {
    //             resolve();
    //             }, ms);
    //         });

    //     const optionsPerPage = 10;

    //     const loadOptions = async (search, page) => {
    //         await sleep(1000);

    //         let filteredOptions;
    //         if (!search) {
    //             filteredOptions = options;
    //         }
    //         else {
    //             const searchLower = search.toLowerCase();
    //             filteredOptions = options.filter(({ label }) =>
    //             label.toLowerCase().includes(searchLower)
    //             );
    //         }

    //         const hasMore = Math.ceil(filteredOptions.length / optionsPerPage) > page;
    //         const slicedOptions = filteredOptions.slice(
    //             (page - 1) * optionsPerPage,
    //             page * optionsPerPage
    //         );

    //         return {
    //             options: slicedOptions,
    //             hasMore
    //         };
    //     };
    // }

    _getMerchList = async (merch_config, search, loadedOptions, { page } ) => {
        let columna = '';
        let columnb = '';
        let columnc = '';
        if(merch_config === "State_Level"){
            columna = 'state_id';
            columnb = 'state_name';
            columnc = 'state_id';
        }
        if(merch_config === "City_Level"){
            columna = 'city_id';
            columnb = 'city_name';
            columnc = 'city_id';
        }
        if(merch_config === "Merchant_Level"){
            columna = 'merchant_id';
            columnb = 'merchant_name';
            columnc = 'merchant_code';
        }
        if(merch_config === "Chain_Level"){
            columna = 'chain_id';
            columnb = 'chain_name';
            columnc = 'chain_code';
        }
        if(merch_config === "Store_Level"){
            columna = 'store_id';
            columnb = 'store_name';
            columnc = 'store_code';
        }
        this.setState({
            slicedMerchValues: []
        });
        let res = await axios.get(config.get('API_URL') + "/brandemi/get_merch_values/?merch_config="+merch_config+"&search="+search+"&page="+page, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        });
        //console.log(res.data);
        let hasMore = false;
        if(Array.isArray(res.data) && res.data.length) {
            hasMore = true;
        }
        res.data.map((str, index) => {
            console.log(columna);
            console.log(columnb);
            this.state.slicedMerchValues.push({value: str[columna], label: str[columnb], value1: str[columnc]})
        });
        //console.log(this.state.slicedMerchValues);
        return {
            options: this.state.slicedMerchValues,
            hasMore: hasMore,
            additional: {
                page: page + 1,
            },
        };
    };

    _getRefineList = async (merch_config, search, loadedOptions, { page } ) => {
        console.log(merch_config);
        let columna = '';
        let columnb = '';
        let columnc = '';
        let columnd = '';
        let relevant_id = '$ab';
        let select_option = [{
            value: 9, label:'Select All', value1: 9
        }]

        if(merch_config === "Merchant_Level"){
            columna = 'merchant_id';
            columnb = 'merchant_name';
            columnc = 'merchant_code';
            relevant_id = this.state.city_ida.value;
        }
        if(merch_config === "Chain_Level"){
            columna = 'chain_id';
            columnb = 'chain_name';
            columnc = 'chain_code';
            relevant_id = this.state.merchant_ida.value1;
            console.log(this.state.merchant_ida);
        }
        if(merch_config === "Store_Level"){
            columna = 'store_id';
            columnb = 'store_name';
            columnc = 'store_code';
            relevant_id = this.state.chain_ida.value;
        }
        this.setState({
            slicedMerchValues: []
        });
        let res = await axios.get(config.get('API_URL') + "/brandemi/get_refined_values/?merch_config="+merch_config+"&relevant_id="+relevant_id+"&search="+search+"&page="+page, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        });
        //console.log(res.data);
        let hasMore = false;
        if(Array.isArray(res.data) && res.data.length) {
            hasMore = true;
        }
        this.state.slicedMerchValues.push({label: 'Select All', options: select_option})
        res.data.map((str, index) => {
            console.log(columna);
            console.log(columnb);
            let vary_option = [{
                value:str[columnc], label: str[columnb], value1: str[columnc]
            }];
            //this.state.slicedMerchValues.push({value: str[columnc], label: str[columnb], value1: str[columnc]})
            this.state.slicedMerchValues.push({label: 'Store', options: vary_option})
        });
        //console.log(this.state.slicedMerchValues);
        return {
            options: this.state.slicedMerchValues,
            hasMore: hasMore,
            additional: {
                page: page + 1,
            },
        };
    };

    updateMerchValues = (optionSelected, valuer) => {
        //console.log(optionSelected);
        if (optionSelected === null){
            this.setState({
                selectedMerchValues: [],
                mapField2: false
            });
        }
        else{
            this.setState({
                selectedMerchValues: optionSelected,
                merchant_ida: valuer,
                mapField2: false
            });
        }
    };


    updateMerchRefineValues = (optionSelected, valuer) => {
        //console.log(optionSelected);
        //console.log(valuer);
        if (optionSelected === null){
            this.setState({
                selectedMerchValues: [],
                selectedRefineSubvention: [],
                mapField2: false
            });
        }
        else{
            if (optionSelected == 'Merchant_Level')
            {
                this.setState({
                    selectedRefineSubvention: optionSelected,
                    merchant_ida: valuer,
                    chain_ida: '',
                    store_ida: '',
                    mapField2: false
                });
            }
            else if (optionSelected == 'Chain_Level')
            {
                this.setState({
                    selectedRefineSubvention: optionSelected,
                    chain_ida: valuer,
                    store_ida: '',
                    mapField2: false
                });
            }
            else if (optionSelected == 'store_Level')
            {
                this.setState({
                    selectedRefineSubvention: optionSelected,
                    store_ida: valuer,
                    mapField2: false
                });
            }
        }
    };

    updateCity = (optionSelected) => {
        this.setState({
            selectedCity: optionSelected.value,
            mapField2: false
        })
    };

    updateMerchantSubvention = (optionSelected) => {
        let refinerMerch = [...this.state.refinerMerch];     // create the copy of state array
        refinerMerch[0] = false;
        refinerMerch[1] = false;
        refinerMerch[2] = false;
        refinerMerch[3] = false;
        refinerMerch[4] = false;

        if (optionSelected.value === "All_Level")
        {
            this.setState({
                selectedMerchantSubvention: optionSelected.value,
                refinerMerch,
                mapField2: false,
                selectedMerchValues: [],
                slicedMerchValues: [],
                refineSearch: false
            });
        }
        else if (optionSelected.value === "State_Level")
        {
            refinerMerch[0] = true;
            this.setState({
                selectedMerchantSubvention: optionSelected.value,
                refinerMerch,
                mapField2: false,
                selectedMerchValues: [],
                slicedMerchValues: [],
                refineSearch: false
            });
        }
        else if (optionSelected.value === "City_Level")
        {
            refinerMerch[0] = true;
            refinerMerch[1] = true;

            this.setState({
                selectedMerchantSubvention: optionSelected.value,
                refinerMerch,
                mapField2: false,
                selectedMerchValues: [],
                slicedMerchValues: [],
                refineSearch: false
            });
        }
        else if (optionSelected.value === "Merchant_Level")
        {
            refinerMerch[0] = true;
            refinerMerch[1] = true;
            refinerMerch[2] = true;

            this.setState({
                selectedMerchantSubvention: optionSelected.value,
                refinerMerch,
                mapField2: false,
                selectedMerchValues: [],
                slicedMerchValues: [],
                refineSearch: false
            });
        }
        else if (optionSelected.value === "Chain_Level")
        {
            refinerMerch[0] = true;
            refinerMerch[1] = true;
            refinerMerch[2] = true;
            refinerMerch[3] = true;


            this.setState({
                selectedMerchantSubvention: optionSelected.value,
                refinerMerch,
                mapField2: false,
                selectedMerchValues: [],
                slicedMerchValues: [],
                refineSearch: false

            });
        }
        else{
            refinerMerch[0] = true;
            refinerMerch[1] = true;
            refinerMerch[2] = true;
            refinerMerch[3] = true;
            refinerMerch[4] = true;

            this.setState({
                selectedMerchantSubvention: optionSelected.value,
                refinerMerch,
                mapField2: false,
                selectedMerchValues: [],
                slicedMerchValues: [],
                refineSearch: false
            });
        }
    };

    updateBankSubvention = (index, optionSelected) => {
        if (optionSelected.value === "NA"){
            this.setState({
                disabler_list: {...this.state.disabler_list, [index]:true}
            });
        }
        else{
            this.setState({
                disabler_list: {...this.state.disabler_list, [index]:false}
            });
        }
        this.setState({
            bank_subvention_list: {...this.state.bank_subvention_list, [index]:optionSelected.value},
            mapField2: false
        })
    };

    disabler(index){
        this.setState({
            disabler_list: {...this.state.disabler_list, [index]:false}
        });
    }

    handleFromChange = date => {
        this.setState({
            startDate: moment(date).format('YYYY-MM-DD'),
            mapField2: false
        });
    };

    handleToChange = date => {
        this.setState({
            endDate: moment(date).format('YYYY-MM-DD'),
            mapField2: false,
            end_date_tracker: 1
        });
    };

    changeSKU = (sku, checked) => {
        //alert(checked)
        let sku_monitor_incr = this.state. q;
        if (checked === true){
            this.setState((state) => ({
                sku_monitor: state.sku_monitor + 1
            }))
        }
        else{
            this.setState((state) => ({
                sku_monitor: state.sku_monitor - 1
            }))
        }
        this.setState({
            sku_list: {...this.state.sku_list, [sku]:checked},
            mapField2: false,
            mapField: false
        });
    };

    skuMapping() {
        //console.log("hello world");
    }

    toggleConfirmationModel() {
        //if (this.state.sku_list.length == 0){
        if (this.state.sku_monitor === 0){
            this.handleNotificationClick("tr", 3, "Select atleast one SKU");
        }
        else{
            this.setState({
                newConfirmationModel: !this.state.newConfirmationModel
            });
        }
    }

    openSectionToMap = (status) => {
        this.setState({
            mapField: status
        })
    };

    sendBankMappings(value) {
        let value1 = 0;
        //console.log(this.state.activer);
        let value2 = this.state.bank_name_list.map((values, index) => {
            if(this.state.activer[index] === true){
                value1 = 1;
            }
        });
        if (value1 === 0) {
            this.handleNotificationClick("tr", 3, "Select atleast one bank.");
        }
        else {
            this.openSectionToMap(value);
        }
        if(this.myRef.current){
            this.myRef.current.scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            })
        }
    }

    updateMapVisiblity = (value) => {
        //console.log(JSON.stringify(value));
        this.setState({
            mapField: value
        })
    };

    changeActiver(index, checked) {
        this.setState({
            activer: {...this.state.activer, [index]:checked.target.checked },
            mapField: false

        });
    }

    changeEMIstatus(index, checked) {
        this.setState({
            isEMI: {...this.state.isEMI, [index]:checked.target.checked},
            mapField2: false
        })
    }

    changeZeroCoststatus(index, checked) {
        this.setState({
            zeroCost: {...this.state.zeroCost, [index]:checked.target.checked},
            mapField2: false
        })
    }

    changeisUpfrontstatus(index, checked) {
        this.setState({
            isUpfront: {...this.state.isUpfront, [index]:checked.target.checked},
            mapField2: false
        })
    }

    sendCompleteScheme = () =>{
        this.setState({

        });
        const data = new FormData();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        let date1 = moment(this.state.startDate).format('YYYY-MM-DD');
        let date2 = new Date(this.state.endDate);
        if(this.state.end_date_tracker == 0){
            date2.setDate(date2.getDate() - 1 );
        }
        date2 = moment(date2).format('YYYY-MM-DD');
        data.append('promotion_id', this.props.match.params.id);
        data.append('activer', JSON.stringify(this.state.activer));
        data.append('zero_cost', JSON.stringify(this.state.zeroCost));
        data.append('is_emi', JSON.stringify(this.state.isEMI));
        data.append('brand_sub_list', JSON.stringify(this.state.brand_subvention_list));
        data.append('brand_sub_value', JSON.stringify(this.state.brand_subvention_value));
        // data.append('sku_list', JSON.stringify(this.state.sku_list);
        data.append('sku_list', JSON.stringify(this.state.sku_list));
        data.append('user_id', decoded._id);
        data.append('start_date', date1);
        data.append('end_date', date2);
        data.append('max_cashback', this.state.maxTxnAmount);
        data.append('isUpfront', JSON.stringify(this.state.isUpfront));
        data.append('maximum_cashback', JSON.stringify(this.state.maximum_cashback));
        // data.append('state_data', JSON.stringify(this.state.state_ida));
        // data.append('city_data', JSON.stringify(this.state.city_ida));
        // data.append('merchant_data', JSON.stringify(this.state.merchant_ida));
        // data.append('chain_data', JSON.stringify(this.state.chain_ida));
        // data.append('store_data', JSON.stringify(this.state.store_ida));
        data.append('isRefine', 1);
        data.append('camp_name', this.state.campaign_name);
        data.append('camp_desc', this.state.campaign_desc);
        //data.append('merchant_final_data', JSON.stringify(this.state.merchant3_data));
        //data.append('file_name', this.state.file_name);
        //data.append('stored_file_name', this.state.merchant_file_name);
        data.append('scheme_master_list',JSON.stringify(this.state.scheme_master_list))
        // data.append('scheme_file_name', this.state.scheme_mapping_file_name);
        // data.append('scheme_stored_file_name', this.state.scheme_mapping_stored_file_name);
        data.append('merchant_master_list', JSON.stringify(this.state.merchant_master_list));
        data.append('merchant_master_data', JSON.stringify(this.state.merchant2_display_data));
        data.append('party_master_id', this.state.party_master_id);
        data.append('merchant_list', JSON.stringify(this.state.merchantValue));
        data.append('chain_list', JSON.stringify(this.state.chainValue));
        data.append('store_list', JSON.stringify(this.state.storeValue));
        data.append('freeemi_wallet', this.state.freeemi_wallet);

        axios.post(config.get('API_URL') + '/brandemi/new_submit_edit_promotion', data, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(res => {
            console.log(res);
            // this.handleNotificationClick("tr", 1, "Data successfully uploaded");
            // this.toggleConfirmationModel();
            // const yourFunction = async () => {
            //     await new Promise(resolve => setTimeout(resolve, 3000)); // 3 sec
            //     console.log("Waited 5s");
            //     this.props.history.push('/admin/view-campaign')
            // };
            // yourFunction();
            this.props.history.push('/admin/admin-promotion-master')

            //this.changeRedirect();
        }).catch(err => {

        })
    };

    whetherDisabled(index){
        if (this.state.brand_subvention_list[index] === "Percent"){
            return false;

        }
        else{
            return true;
        }
    }

    changeScheme = (id, checked) => {
        let scheme_monitor_incr = this.state.scheme_monitor;
        if (checked === true){
            this.setState((state) => ({
                scheme_monitor: state.scheme_monitor + 1
            }))
        }
        else{
            this.setState((state) => ({
                scheme_monitor: state.scheme_monitor - 1
            }))
        }
        this.setState({
            scheme_master_list: {...this.state.scheme_master_list, [id]:checked}
        });
    };


    changeMerchant = (id, checked) => {
        let merchant_monitor_incr = this.state.merchant_monitor;
        if (checked === true){
            this.setState((state) => ({
                merchant_monitor: this.state.merchant_monitor + 1
            }))
        }
        else{
            this.setState((state) => ({
                merchant_monitor: this.state.merchant_monitor - 1
            }))
        }
        this.setState({
            merchant_master_list: {...this.state.merchant_master_list, [id]:checked}
        });
    };

    evalMerchantCounter(){
        //if (this.state.merchant_counter > 0){
        //let merchant_counter_array = this.state.merchant_counter_array.concat[0];
        this.setState({
            merchant_counter: this.state.merchant_counter + 1,
            merchant_counter_array: this.state.merchant_counter_array.concat([0])
        })
        //}
        // else{
        //     let merchant_counter_array = this.state.merchant_counter_array.concat[0];
        //     this.setState({
        //         merchant_counter: this.state.merchant_counter + 1,
        //         follower: !this.state.follower,
        //         merchant_counter_array
        //     })
        // }

    }

    negEvalMerchantCounter(){
        this.state.merchant_counter_array.pop()
        this.setState({
            merchant_counter: this.state.merchant_counter + 1,
            //merchant_counter_array: this.state.merchant_counter_array.pop()
        });
    }

    tabClicker(value){
        if(value == 1){
            this.setState({
                stepper: {...this.state.stepper, [1]: true},
                stepper: {...this.state.stepper, [2]: true},
                stepper: {...this.state.stepper, [3]: true}
            })
        }
    }

    render() {
        console.log("abc");
        console.log("a",this.state.sku_list);
        console.log("b",this.state.scheme_master_list);
//         console.log("c", this.state.brand_user_id);
//         console.log("d", this.state.sku_list);
//         console.log("e", this.state.scheme_master_list);
//         console.log("f", this.state.scheme_activer);
//         console.log("g", this.state.activer);
//         console.log("h", this.state.merchant_master_list);
//         console.log("i", this.state.merchantList);
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }

        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "15px",
                margin: "0px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px",
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px",
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "15px",
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px',
            }),
            menu: styles => ({ ...styles, zIndex: 999})
        };

        let merchant_displayer = () => {
            if(decoded.userGroup == 2 || decoded.userGroup == '2'){
                return(<div></div>)
            }
            else{
                return(
                    <div className="row">
                        <div className="col-md-4">
                            <Label>Select Merchant:</Label>
                            <ReactMultiSelectCheckboxes name={"merchant_selector"}
                                                        components={{ MenuList }}
                                                        isClearable={false}
                                                        onChange={this.changeMerchant1.bind(this)}
                                                        styles={customStyles} className="report-listbox"
                                                        options={this.state.merchantList}
                                                        value={this.state.merchantValue}
                                                        isMulti
                                                        placeholderButtonLabel="All"
                            />
                        </div>
                        <div className="col-md-4">
                            <Label>Select Chain:</Label>
                            <ReactMultiSelectCheckboxes name={"chain_selector"}
                                                        components={{ MenuList }}
                                                        isClearable={false}
                                                        onChange={this.changeChain.bind(this)}
                                                        styles={customStyles} className="report-listbox"
                                                        options={this.state.chainList}
                                                        value={this.state.chainValue}
                                                        isMulti
                                                        placeholderButtonLabel="All"
                            />
                        </div>
                        <div className="col-md-4">
                            <Label>Select Store:</Label>
                            <ReactMultiSelectCheckboxes name={"store_selector"}
                                                        components={{ MenuList }}
                                                        isClearable={false}
                                                        onChange={this.changeStore.bind(this)}
                                                        styles={customStyles} className="report-listbox"
                                                        options={this.state.storeList}
                                                        value={this.state.storeValue}
                                                        isMulti
                                                        placeholderButtonLabel="All"
                            />
                        </div>
                    </div>
                )
            }
        }

        let scheme_data_master = this.state.scheme_master_data.map((value, index) =>{
            let timer2 = new Date(value.recordUpdateTimestamp)
              timer2.setHours(timer2.getHours() + 5);
              timer2.setMinutes(timer2.getMinutes() + 30);
              // timer
              let timer3 = timer2.toJSON().slice(0, 19).replace('T', ' ');
            let cashback_render = '';
            let brand_sub_render = value.brand_sub;
            let brand_sub_amount_render = value.brand_sub_amount;
            let tenure_render = value.tenure;
            let scheme_type = 'Brand EMI';
            let emi_typea = 'Non EMI';
            if (value.is_emi == 0 || value.is_emi == '0'){
                tenure_render = 'NA';
            }
            else if(value.is_emi == 1 || value.is_emi == '1'){
                emi_typea = 'Zero Cost'
            }
            else if(value.is_emi == 2 || value.is_emi == '2'){
                emi_typea = 'Low Cost'
            }
            if (value.is_cashback == 0 || value.is_cashback == '0'){
                cashback_render = 'No';
                brand_sub_render = 'NA';
                brand_sub_amount_render = 'NA';
            }
            else{
                cashback_render = 'Yes';
            }
            if(value.scheme_type == 'exclusiveemi'){
                scheme_type = 'Exclusive EMI';
            }
            else if(value.scheme_type == 'freeemi'){
                scheme_type = 'Free EMI';
            }
//             let max_cashback_render = value.max_cashback.slice(0, -1);
//             //if(max_cashback_render == -1 || max_cashback_render == '-1'){
//             if(max_cashback_render == '0.00'){
//                 max_cashback_render = 'NA';
//             }
            return (
                <tr key={index + 1}>
                    <td>{value.schemeName}</td>
                     <td>{value.bankName}</td>
                     <td>{value.schemeType}</td>
                     <td>{value.emiType}</td>
                      <td>{value.tenure}</td>
                      <td>{value.availCashback}</td>
                       <td>{value.upfrontCashbackBrand}</td>
                      <td>{value.upfrontCashbackBank}</td>
                      <td>{value.postCashbackBrand}</td>
                      <td>{value.postCashbackBank}</td>
                    <td>{value.lowCostSubvention}</td>
                    <td>{value.upfrontBrandSub}</td>
                    <td>{value.upfrontBrandSubAmount}</td>
                    <td>{value.upfrontMaxCashback}</td>
                    <td>{timer3}</td>
                    <td>
                        <Switch
    className="react-switch"
    height={20}
    width={38}
    id={index + "_"}
    onColor="#484b9a"
    onChange={(checked) => this.changeScheme(value.id, checked)}
    checked={!!this.state.scheme_master_list[value.id]}
/>

                    </td>
                </tr>
            )
        });
        let merchant_data_master = null;
        if(this.state.party_master_id != null && this.state.merchant2_display_data.length != 0){
            merchant_data_master = this.state.merchant2_display_data.map((value, index) =>{
                // console.log(value.field_1);

                return (
                    <tr key={index + 1}>
                        <td>{value.merchant_id}</td>
                        <td>{value.merchant_name}</td>
                        <td>{value.merchant_code}</td>
                        <td>{value.chain_id}</td>
                        <td>{value.chain_name}</td>
                        <td>{value.chain_code}</td>
                        <td>{value.store_id}</td>
                        <td>{value.store_name}</td>
                        <td>{value.store_code}</td>
                        <td>{value.store_address}</td>
                        <td>{value.field_1}</td>
                        <td>
                            <Switch className="react-switch"
                                    height={20} width={38}
                                    id={index + "_"}
                                    onColor="#484b9a"
                                    onChange={this.changeMerchant.bind(this, value.id)}
                                    checked={(this.state.merchant_master_list[value.id])? true : false}
                            />
                        </td>
                    </tr>
                )

            });
        }
        //console.log(this.state.selectedMerchantSubvention);
        //console.log(this.state.sku_list);
        //console.log(this.state.selectedMerchValues);
        //console.log(this.state.state_ida.value);
        //console.log(this.state.city_ida.value);
        //console.log(this.state.merchant_ida.value);
        //console.log(this.state.chain_ida.value);
        //console.log(this.state.refinerMerch);


        //const { redirect } = this.state;
        let bank_activer = this.state.activer;
        let start_date = (this.state.startDate); //.toDateString();
        let end_date = new Date(this.state.endDate);
        if(this.state.end_date_tracker == 0){
            end_date.setDate( end_date.getDate() - 1 );
        }
        let end_date2 = end_date;
        let max_txn = this.state.maxTxnAmount;
        // console.log(this.state.endDate);
        // console.log(this.state.end_date_tracker);
        // console.log(end_date);
        // console.log(end_date2);
        let subvention_data = this.state.bank_name_list.map((value, index) => {
            let vala = '';
            if (this.state.brand_subvention_list[index] === 'Percent'){
                vala = this.state.maximum_cashback[index];
            }
            else{
                vala = 'NA';
            }
            if(bank_activer[index] === true)
            {
                if(this.state.isEMI[index] === true)
                {
                    return(
                        <tr key= {index + " " + this.state.bank_name_list[index]}>
                            <td className="tdmodal">{index+1}</td>
                            <td className="tdmodal">{this.state.bank_name_list[index]}</td>
                            <td className="tdmodal">Yes</td>
                            <td className="tdmodal">{this.state.zeroCost[index]? "Yes": "No"}</td>
                            <td className="tdmodal">{this.state.bankOptions[index]['M3']? "Yes": "No"}</td>
                            <td className="tdmodal">{this.state.bankOptions[index]['M6']? "Yes": "No"}</td>
                            <td className="tdmodal">{this.state.bankOptions[index]['M9']? "Yes": "No"}</td>
                            <td className="tdmodal">{this.state.bankOptions[index]['M12']? "Yes": "No"}</td>
                            <td className="tdmodal">{this.state.bankOptions[index]['M18']? "Yes": "No"}</td>
                            <td className="tdmodal">{this.state.bankOptions[index]['M24']? "Yes": "No"}</td>
                            <td className="tdmodal">{this.state.brand_subvention_list[index] + ": " + this.state.brand_subvention_value[index]}</td>
                            <td className="tdmodal">{vala}</td>
                        </tr>
                    );
                }
                else{
                    return(
                        <tr key= {index + " " + this.state.bank_name_list[index]}>
                            <td className="tdmodal">{index+1}</td>
                            <td className="tdmodal">{this.state.bank_name_list[index]}</td>
                            <td className="tdmodal">No</td>
                            <td className="tdmodal">NA</td>
                            <td className="tdmodal">NA</td>
                            <td className="tdmodal">NA</td>
                            <td className="tdmodal">NA</td>
                            <td className="tdmodal">NA</td>
                            <td className="tdmodal">NA</td>
                            <td className="tdmodal">NA</td>
                            <td className="tdmodal">{this.state.brand_subvention_list[index] + ": " + this.state.brand_subvention_value[index]}</td>
                            <td className="tdmodal">{vala}</td>
                            {/* <td className="tdmodal">NA</td> */}
                        </tr>
                    );
                }
            }
            else{
                return(
                    <tr key= {index + " " + this.state.bank_name_list[index]}>
                        <td className="tdmodal">{index+1}</td>
                        <td className="tdmodal">{this.state.bank_name_list[index]}</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                        <td className="tdmodal">NA</td>
                    </tr>
                );
            }
        });

        let sku_show_data = this.state.raw_display_data.map((value,index) => {
            return (
                <tr key={index + 1}>
                    <td>{index+1}</td>
                     <td>{value.manufacturerDisplayName}</td>
                    <td>{value.categoryDisplayName}</td>
                    <td>{value.modelDisplayNumber}</td>
                    <td>{value.modelVersion}</td>
                    <td>{value.modelDisplayNumber}</td>
                    <td>{value.brandSku}</td>
                    <td>{value.productMaxSellingPrice}</td>
                    <td>{value.productMinSellingPrice}</td>
                    <td>
                        <Switch
    className="react-switch"
    height={20}
    width={38}
    id={index + "_"}
    onColor="#484b9a"
    onChange={(checked) => this.changeSKU(value.brandSku, checked)}
    checked={!!this.state.sku_list[value.brandSku]}
/>
                    </td>
                </tr>
            );
        });

        //isDisabled={!(this.state.refinerMerch[2] && this.state.refineSearch)}
        //isDisabled={!(this.state.refinerMerch[3] && this.state.refineSearch)}
        //isDisabled={!(this.state.refinerMerch[4] && this.state.refineSearch)}
        // let refine_search = () => {
        //     return(
        //         <div className="row bottompaddingsubvention">
        //             <div className=" col-sm-6 col-md-3 col-xs-12">
        //                 <Label>Select Merchant</Label>
        //                 <Select name="refineValueMerchant"
        //                     // defaultValue={this.state.selectedMerchValues}
        //                     onChange={this.updateMerchRefineValues.bind(this, "Merchant_Level")}
        //                     options={this.state.brand_has_merchant}
        //                     placeholder="Select Merchant"
        //                     // isClearable={true}
        //                 />
        //             </div>
        //             <div className=" col-sm-6 col-md-3 col-xs-12">
        //                 <Label>Select Chain</Label>
        //                 <AsyncPaginate name="refineValueChain"
        //                     defaultValue={this.state.selectedMerchValues}
        //                     onChange={this.updateMerchRefineValues.bind(this, "Chain_Level")}
        //                     loadOptions={this._getRefineList.bind(this, "Chain_Level")}
        //                     additional={{
        //                         page: 1,
        //                     }}
        //                     placeholder="Select Chain"
        //                     isClearable={true}
        //                     isMulti={true}
        //                 />
        //             </div>
        //             <div className=" col-sm-6 col-md-3 col-xs-12">
        //                 <Label>Select Store</Label>
        //                 <AsyncPaginate name="refineValueStore"
        //                     defaultValue={this.state.selectedMerchValues}
        //                     onChange={this.updateMerchRefineValues.bind(this, "Store_Level")}
        //                     loadOptions={this._getRefineList.bind(this, "Store_Level")}
        //                     additional={{
        //                         page: 1,
        //                     }}
        //                     placeholder="Select Store"
        //                     isClearable={true}
        //                     isMulti={true}
        //                 />
        //             </div>
        //             <div className=" col-sm-6 col-md-3 col-xs-12">
        //                 <Button
        //                 color="primary"
        //                 disabled={this.state.follower}
        //                 onClick={this.evalMerchantCounter.bind(this)}> Add Merchant</Button>{' '}
        //             </div>
        //         </div>
        //     );
        // }

        // let refine_search = this.state.merchant_counter_array.map((values, index) => {
        //     console.log(this.state.merchant_counter);
        //     if (index+1 == this.state.merchant_length){
        //         return(
        //             <div className="row bottompaddingsubvention">
        //                 <div className=" col-sm-6 col-md-3 col-xs-12">
        //                     <Label>Select Merchant</Label>
        //                     <Select name={"refineValueMerchant_" + index}
        //                         // defaultValue={this.state.selectedMerchValues}
        //                         onChange={this.updateMerchRefineValues.bind(this, "Merchant_Level")}
        //                         options={this.state.brand_has_merchant}
        //                         placeholder="Select Merchant"
        //                         // isClearable={true}
        //                     />
        //                 </div>
        //                 <div className=" col-sm-6 col-md-3 col-xs-12">
        //                     <Label>Select Chain</Label>
        //                     <AsyncPaginate name={"refineValueChain_" + index}
        //                         defaultValue={this.state.selectedMerchValues}
        //                         onChange={this.updateMerchRefineValues.bind(this, "Chain_Level")}
        //                         loadOptions={this._getRefineList.bind(this, "Chain_Level")}
        //                         additional={{
        //                             page: 1,
        //                         }}
        //                         placeholder="Select Chain"
        //                         isClearable={true}
        //                         isMulti={true}
        //                         reduceOptions={reduceGroupedOptions}
        //                     />
        //                 </div>
        //                 <div className=" col-sm-6 col-md-3 col-xs-12">
        //                     <Label>Select Store</Label>
        //                     <AsyncPaginate name={"refineValueStore_" + index}
        //                         defaultValue={this.state.selectedMerchValues}
        //                         onChange={this.updateMerchRefineValues.bind(this, "Store_Level")}
        //                         loadOptions={this._getRefineList.bind(this, "Store_Level")}
        //                         additional={{
        //                             page: 1,
        //                         }}
        //                         placeholder="Select Store"
        //                         isClearable={true}
        //                         isMulti={true}
        //                         reduceOptions={reduceGroupedOptions}
        //                     />
        //                 </div>
        //                 <div className=" col-sm-6 col-md-3 col-xs-12">
        //                     <Button color="secondary" className="btn-capitalize" onClick={this.negEvalMerchantCounter.bind(this)}> -</Button>{' '}
        //                 </div>
        //             </div>
        //         );
        //     }
        //     else if(index == 0){
        //         return(
        //         <div className="row bottompaddingsubvention">
        //                 <div className=" col-sm-6 col-md-3 col-xs-12">
        //                     <Label>Select Merchant</Label>
        //                     <Select name={"refineValueMerchant_" + index}
        //                         // defaultValue={this.state.selectedMerchValues}
        //                         onChange={this.updateMerchRefineValues.bind(this, "Merchant_Level")}
        //                         options={this.state.brand_has_merchant}
        //                         placeholder="Select Merchant"
        //                         // isClearable={true}
        //                     />
        //                 </div>
        //                 <div className=" col-sm-6 col-md-3 col-xs-12">
        //                     <Label>Select Chain</Label>
        //                     <AsyncPaginate name={"refineValueChain_" + index}
        //                         defaultValue={this.state.selectedMerchValues}
        //                         onChange={this.updateMerchRefineValues.bind(this, "Chain_Level")}
        //                         loadOptions={this._getRefineList.bind(this, "Chain_Level")}
        //                         additional={{
        //                             page: 1,
        //                         }}
        //                         placeholder="Select Chain"
        //                         isClearable={true}
        //                         isMulti={true}
        //                         reduceOptions={reduceGroupedOptions}
        //                     />
        //                 </div>
        //                 <div className=" col-sm-6 col-md-3 col-xs-12">
        //                     <Label>Select Store</Label>
        //                     <AsyncPaginate name={"refineValueStore_" + index}
        //                         defaultValue={this.state.selectedMerchValues}
        //                         onChange={this.updateMerchRefineValues.bind(this, "Store_Level")}
        //                         loadOptions={this._getRefineList.bind(this, "Store_Level")}
        //                         additional={{
        //                             page: 1,
        //                         }}
        //                         placeholder="Select Store"
        //                         isClearable={true}
        //                         isMulti={true}
        //                         reduceOptions={reduceGroupedOptions}
        //                     />
        //                 </div>
        //                 <div className=" col-sm-6 col-md-3 col-xs-12">
        //                 <Button
        //                 color="primary"
        //                 disabled={this.state.follower}
        //                 className="btn-capitalize"
        //                 onClick={this.evalMerchantCounter.bind(this)}> +</Button>{' '}
        //                 </div>
        //             </div>
        //         );
        //     }
        //     else{
        //         return(
        //             <div className="row bottompaddingsubvention">
        //                 <div className=" col-sm-6 col-md-3 col-xs-12">
        //                     <Label>Select Merchant</Label>
        //                     <Select name={"refineValueMerchant_" + index}
        //                         // defaultValue={this.state.selectedMerchValues}
        //                         onChange={this.updateMerchRefineValues.bind(this, "Merchant_Level")}
        //                         options={this.state.brand_has_merchant}
        //                         placeholder="Select Merchant"
        //                         // isClearable={true}
        //                     />
        //                 </div>
        //                 <div className=" col-sm-6 col-md-3 col-xs-12">
        //                     <Label>Select Chain</Label>
        //                     <AsyncPaginate name={"refineValueChain_" + index}
        //                         defaultValue={this.state.selectedMerchValues}
        //                         onChange={this.updateMerchRefineValues.bind(this, "Chain_Level")}
        //                         loadOptions={this._getRefineList.bind(this, "Chain_Level")}
        //                         additional={{
        //                             page: 1,
        //                         }}
        //                         placeholder="Select Chain"
        //                         isClearable={true}
        //                         isMulti={true}
        //                         reduceOptions={reduceGroupedOptions}
        //                     />
        //                 </div>
        //                 <div className=" col-sm-6 col-md-3 col-xs-12">
        //                     <Label>Select Store</Label>
        //                     <AsyncPaginate name={"refineValueStore_" + index}
        //                         defaultValue={this.state.selectedMerchValues}
        //                         onChange={this.updateMerchRefineValues.bind(this, "Store_Level")}
        //                         loadOptions={this._getRefineList.bind(this, "Store_Level")}
        //                         additional={{
        //                             page: 1,
        //                         }}
        //                         placeholder="Select Store"
        //                         isClearable={true}
        //                         isMulti={true}
        //                         reduceOptions={reduceGroupedOptions}
        //                     />
        //                 </div>
        //                 <div className=" col-sm-6 col-md-3 col-xs-12">
        //                     <Button color="primary" className="btn-capitalize" onClick={this.evalMerchantCounter.bind(this)}> +</Button>{' '}
        //                     <Button color="secondary" className="btn-capitalize" onClick={this.negEvalMerchantCounter.bind(this)}> -</Button>{' '}
        //                 </div>
        //             </div>
        //         );
        //     }
        // });

        // let bank_names = this.state.bank_name_list.map((value,index) => {
        //     //console.log(this.state.isEMI[index]);
        //     let valuera = false;
        //     let brand_e_valuer = this.state.brand_subvention_value[index]
        //     if (this.state.brand_subvention_list[index] === "Percent"){
        //         valuera = false;
        //     }
        //     else{
        //         valuera = true;
        //     }
        //     if (bank_activer[index] === true){
        //        // if ( this.state.isEMI[index] === true)
        //         return <div className="col-md-3 col-sm-6 col-xs-12 " key={index}>
        //             <div className="card p-5">
        //             <h5>{this.state.bank_name_list[index]}</h5>
        //             <Checkbox number={index + " " + value} label="EMI Scheme Applicable?" onChange={this.changeEMIstatus.bind(this, index)} checked={!!this.state.isEMI[index]}/>
        //             <Checkbox  number={"zero_cost_" + index}  label="Zero Cost EMI?" onChange={this.changeZeroCoststatus.bind(this, index)} disabled={this.state.isEMI[index]? false : true} checked={!!(this.state.zeroCost[index])} />
        //             <div className="row">
        //                 <div className="col-md-6 col-sm-12">
        //                     <Checkbox className="checkboxmargin" number={"3_months_" + index}  label="3 months" onChange={this.changeTenure.bind(this, index, 'M3')} disabled={this.state.isEMI[index]? false : true} checked={!!(this.state.bankOptions[index]['M3'])} />
        //                 </div>
        //                 <div className="col-md-6 col-sm-12">
        //                     <Checkbox className="checkboxmargin" number={"6_months_" + index}  label="6 months" onChange={this.changeTenure.bind(this, index, 'M6')} disabled={this.state.isEMI[index]? false : true} checked={!!(this.state.bankOptions[index]['M6'])} />
        //                 </div>
        //             </div>
        //             <div className="row">
        //                 <div className="col-md-6 col-sm-12">
        //                     <Checkbox className="checkboxmargin" number={"9_months_" + index}  label="9 months" onChange={this.changeTenure.bind(this, index, 'M9')} disabled={this.state.isEMI[index]? false : true} checked={!!(this.state.bankOptions[index]['M9'])} />
        //                 </div>
        //                 <div className="col-md-6 col-sm-12">
        //                     <Checkbox className="checkboxmargin" number={"12_months_" + index}  label="12 months" onChange={this.changeTenure.bind(this, index, 'M12')} disabled={this.state.isEMI[index]? false : true} checked={!!(this.state.bankOptions[index]['M12'])} />
        //                 </div>
        //             </div>
        //             <div className="row">
        //                 <div className="col-md-6 col-sm-12">
        //                     <Checkbox className="checkboxmargin" number={"18_months_" + index}  label="18 months" onChange={this.changeTenure.bind(this, index, 'M18')} disabled={this.state.isEMI[index]? false : true} checked={!!(this.state.bankOptions[index]['M18'])} />
        //                 </div>
        //                 <div className="col-md-6 col-sm-12">
        //                     <Checkbox className="checkboxmargin" number={"24_months_" + index}  label="24 months" onChange={this.changeTenure.bind(this, index, 'M24')} disabled={this.state.isEMI[index]? false : true} checked={!!(this.state.bankOptions[index]['M24'])} />
        //                 </div>
        //             </div>
        //         <Label className="labela"> Brand Subvention </Label>
        //         <div className="row m-0 bottompaddingsubvention">
        //             <div className=" col-xs-8 pr-0">
        //                 <Select name={"brandSubventionCol_" + index}
        //                 className="brandSubventionCol"
        //                 isClearable={false}
        //                 options={this.state.brandSubventionOptions}
        //                 value={this.state.brand_subvention_list[index]}
        //                 placeholder={this.state.brand_subvention_list[index]}
        //                 onChange={this.updateBrandSubvention.bind(this, index)}
        //                 />
        //             </div>
        //             <div className=" col-xs-4 pl-0">
        //                 <Input id={"brand_value_" + index} className="form-control-subvention" defaultValue={brand_e_valuer} onChange={(e)=> {
        //                 let {brand_value} = this.state;
        //                 brand_value = e.target.value;
        //                 if(((e.target.value)*1) < 0 || (e.target.value === '')){
        //                     this.handleNotificationClick("tr", 3, "Insert value greater than 0");
        //                 }
        //                 this.setState({
        //                     brand_subvention_value: {...this.state.brand_subvention_value, [index]:brand_value},
        //                     mapField2: false
        //                 })
        //             }}/>
        //             </div>
        //         </div>

        //         <Label className="labela"> Maximum Cashback </Label>
        //         <div className="row m-0">
        //             <div className=" col-xs-8 pl-0">
        //                 <Input id={"max_cashback_" + index} className="form-control-subvention" disabled={valuera} value={this.state.maximum_cashback[index]} onChange={(e)=> {
        //                     let {max_cashback} = this.state;
        //                     max_cashback = e.target.value;
        //                     if(((e.target.value)*1) < 0 || (e.target.value === '')){
        //                         this.handleNotificationClick("tr", 3, "Insert value greater than 0");
        //                     }
        //                     this.setState({
        //                         maximum_cashback: {...this.state.maximum_cashback, [index]:max_cashback},
        //                         mapField2: false
        //                     })
        //                 }}/>
        //             </div>
        //         </div>
        //         <div className="row m-0">
        //             <Checkbox number={"isUpfront_" + index} label="Cashback is upfront?" onChange={this.changeisUpfrontstatus.bind(this, index)} checked={!!(this.state.isUpfront[index])} />
        //         </div>
        //             </div>
        //         </div>
        //     }
        // });

        // let refine_disabler = false;
        // if (this.state.selectedMerchantSubvention == "All_Level" || this.state.selectedMerchantSubvention == "State_Level"){
        //         refine_disabler = true;
        // }
        // else{
        //     refine_disabler = false;
        // }

        // let selected_merch_refine1 = () => {
        //     if (this.state.refineSearch == true){
        //         return this.state.selectedRefineSubvention;
        //     }
        //     else{
        //         return this.state.selectedMerchantSubvention;
        //     }
        // }

        // let selected_merch_refine = () => {
        //     if (this.state.refineSearch == true){
        //         return this.state.merchant_ida.label;
        //     }
        //     else{
        //         return this.state.selectedMerchValues[0];
        //     }
        // }
        let variabler = this.state.current_tab;
        let active_finder = '';
        if (this.state.scheme_active == 1 || this.state.scheme_active == '1'){
            active_finder = ' - Approved';
        }
        else if(this.state.scheme_active == 0 || this.state.scheme_active == '0'){
            active_finder = ' - Created';
        }
        else if(this.state.scheme_active == 2 || this.state.scheme_active == '2'){
            active_finder = ' - Configured';
        }
        else if(this.state.scheme_active == 3 || this.state.scheme_active == '3'){
            active_finder = ' - QA verified';
        }
        else if(this.state.scheme_active == 4 || this.state.scheme_active == '4'){
            active_finder = ' - Active';
        }
        else if(this.state.scheme_active == -1 || this.state.scheme_active == '-1'){
            active_finder = ' - Rejected';
        }
        // else{
        //     active_finder = ' - Expired';
        // }
        let campaign_header = this.state.campaign_name + active_finder;


        return(
            <div className="content">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />
                <CommonNavbar/>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 top-pad-5">
                            <div className="card">
                                <div className="header">
                                    <h4 className="title">{campaign_header}</h4>
                                </div>
                                <div className="content">
                                    <div className='sweet-loading'>
                                        <BeatLoader
                                            css={override}
                                            sizeUnit={"px"}
                                            size={20}
                                            color={'#123abc'}
                                            loading={this.state.loading}
                                        />
                                    </div>
                                    {/* defaultTab="vertical-tab-two" */}
                                    <Tabs defaultTab={variabler} vertical className="vertical-tabs">
                                        <TabList>
                                            <Tab className="tab-title" tabFor="vertical-tab-one" onClick={this.tabClicker.bind(this, 1)}>
                                                <h4 className='title'>Products</h4>
                                                <span className='text-muted'>
                                                    Update products
                                                </span>
                                            </Tab>
                                            <Tab className="tab-title" tabFor="vertical-tab-two" onClick={this.tabClicker.bind(this, 2)}>
                                                <h4 className='title'> Schemes</h4>
                                                <span className='text-muted'>
                                                    Update schemes
                                                </span>
                                            </Tab>
                                            <Tab className="tab-title" tabFor="vertical-tab-three" onClick={this.tabClicker.bind(this, 3)}>
                                                <h4 className='title'>  Merchants</h4>
                                                <span className='text-muted'>
                                                    Update merchants
                                                </span>
                                            </Tab>
                                            <Tab className="tab-title" tabFor="vertical-tab-four" onClick={this.tabClicker.bind(this, 4)}>
                                                <h4 className='title'>  Details</h4>
                                                <span className='text-muted'>
                                                    Update details
                                                </span>
                                            </Tab>
                                        </TabList>
                                        <TabPanel tabId="vertical-tab-one">
                                            {/* <Collapse isOpen={this.state.mapField0}>     */}
                                            <div className="card-query-builder" >
                                                {/* <NotificationSystem ref="notificationSystem" style={style} />
                                                <ReactTooltip /> */}
                                                <div className="col-md-12">
                                                    <div className="card noshadow" ref={this.myRef2}>
                                                        <div className="header header-promotion">
                                                            <h4 className="title">Products</h4>
                                                            <span className='text-muted'>Update your products for this promotion</span>
                                                        </div>

                                                        <Modal className="modalsmall" isOpen={this.state.newConfirmationModel}
                                                               toggle={this.toggleConfirmationModel.bind(this)}
                                                               size="lg"
                                                        >
                                                            <ModalBody>
                                                                <div className="row">
                                                                    <div className="col-xs-12 ">
                                                                        <h4 className="modalh4">Are you sure you want to save?</h4>
                                                                    </div>
                                                                </div>
                                                            </ModalBody>
                                                            <ModalFooter>
                                                                <Button color="primary" className="btn-capitalize" onClick={this.sendCompleteScheme}>Yes</Button>{' '}
                                                                <Button color="secondary" className="btn-capitalize2" onClick={this.toggleConfirmationModel.bind(this)}>Cancel</Button>
                                                            </ModalFooter>
                                                        </Modal>

                                                        <div className="col-md-12">
                                                            <div className="pull-right">
                                                                <a href="#"  onClick={this.selectAll.bind(this)}>Select all</a>{ '      ' }&nbsp;&nbsp;&nbsp;
                                                                <a href="#"  onClick={this.deSelectAll.bind(this)}>Clear</a>{ '  ' }
                                                            </div>
                                                        </div>
                                                        <div className="table-full-width table-responsive">
                                                            <table className="table table-striped table-hover" id="sku_showTable">
                                                                <thead>
                                                                <tr>
                                                                    <th>Sr No.</th>
                                                                    <th>Brand</th>
                                                                    <th>Category</th>
                                                                    <th>Model Name</th>
                                                                    <th>Model Number</th>
                                                                    <th>Model Description</th>
                                                                    <th>SKU</th>
                                                                    <th>MRP</th>
                                                                    <th>MOP</th>
                                                                    <th>Applicable?</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {sku_show_data}
                                                                </tbody>
                                                            </table>
                                                            <br/>
                                                            <div className="col-md-12">
                                                                <button onClick={this.openSectionToBanks.bind(this, true)} className="btn btn-primary btn-capitalize pull-right">Choose Schemes</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* </Collapse> */}
                                        </TabPanel>
                                        <TabPanel tabId="vertical-tab-two">
                                            <div className="card-query-builder">
                                                <div className="col-md-12">
                                                    <div className="card noshadow" ref={this.myRef2}>
                                                        <div className="header header-promotion">
                                                            <h4 className="title">Schemes</h4>
                                                            <span className="text-muted">Update your schemes for this promotion</span>
                                                        </div>

                                                        <div className="col-md-12">
                                                            <div className="pull-right">
                                                                <a href="#"  onClick={this.selectAllPromotions.bind(this)}>Select all</a>{ '      ' }&nbsp;&nbsp;&nbsp;
                                                                <a href="#"  onClick={this.deselectAllPromotions.bind(this)}>Clear</a>{ '  ' }
                                                            </div>
                                                        </div>
                                                        <div className="table-full-width table-responsive">
                                                            <table className="table table-striped table-hover" id="brandSchemeMasterViewTable">
                                                                <thead>
                                                                <tr>
                                                                    <th>Scheme Name</th>
                                                                    <th>Bank Name</th>
                                                                    <th>Scheme Type</th>
                                                                    <th>EMI Type</th>
                                                                    <th>Tenure</th>
                                                                    <th>Avail Cashback?</th>
                                                                    <th>Upfront Cashback Brand</th>
                                                                    <th>Upfront Cashback Bank</th>
                                                                    <th>Post Cashback Brand</th>
                                                                    <th>Post Cashback Bank</th>
                                                                    <th>Low Cost Subvension</th>
                                                                    <th>Brand Sub</th>
                                                                    <th>Brand Sub Amount</th>
                                                                    <th>Max Cash back</th>
                                                                    <th>Time stamp</th>
                                                                    <th>Applicable?</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {scheme_data_master}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div className="row">
                                                            <div className ="col-md-12">
                                                                <button onClick={this.sendEMIMappings.bind(this, true)} className="btn btn-primary pull-right btn-capitalize">Choose Merchants</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </TabPanel>
                                        <TabPanel tabId="vertical-tab-three">
                                            <div className="col-md-12">

                                                <div className="card noshadow">

                                                    <div className="row">

                                                        <div className="col-md-12">
                                                            <div className="header header-promotion">
                                                                <h4 className="title">Merchants</h4>
                                                                <span className="text-muted">Please select merchants from below list</span>
                                                            </div>
                                                            {merchant_displayer()}
                                                            <div className="row top-margin-10">
                                                                <div className ="col-md-12">
                                                                    <button onClick={this.merchantSubmitHandler.bind(this)} className="btn btn-primary pull-right btn-capitalize">Continue</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="footer">
                                                        <div className="stats"><i></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </TabPanel>
                                        <TabPanel tabId="vertical-tab-four">
                                            <div className="card-query-builder subvention-brand ">
                                                <div className="col-md-12">
                                                    <div className="card noshadow" ref={this.myRef}>
                                                        <div className="header header-promotion">
                                                            <h4 className="title">Promotion Details</h4>
                                                            <span className="text-muted">The following are the promotion details</span>
                                                        </div>

                                                        <div className= "content">
                                                            <div className="row bottompaddingsubvention">
                                                                <div className=" col-sm-6 col-md-3 col-xs-12">
                                                                    <Label>Promotion Name</Label>
                                                                    <Input id="campaign_name"
                                                                           disabled={true}
                                                                           className="maxheighter" value={this.state.campaign_name} onChange={(e)=> {
                                                                        let {campaign_name} = this.state;
                                                                        campaign_name = e.target.value;
                                                                        if((e.target.value === '')){
                                                                            this.handleNotificationClick("tr", 3, "Insert campaign name");
                                                                        }
                                                                        this.setState({
                                                                            campaign_name: campaign_name,
                                                                            mapField2: false
                                                                        })
                                                                    }}/>
                                                                </div>
                                                                <div className=" col-sm-12 col-md-6 col-xs-12">
                                                                    <Label>Promotion Description</Label>
                                                                    <Input id="campaign_desc" className="maxheighter" value={this.state.campaign_desc} onChange={(e)=> {
                                                                        let {campaign_desc} = this.state;
                                                                        campaign_desc = e.target.value;
                                                                        if((e.target.value === '')){
                                                                            this.handleNotificationClick("tr", 3, "Insert campaign description");
                                                                        }
                                                                        this.setState({
                                                                            campaign_desc: campaign_desc,
                                                                            mapField2: false
                                                                        })
                                                                    }}/>
                                                                </div>
                                                            </div>

                                                            <div className="row bottompaddingsubvention2">
                                                                <div className=" col-sm-6 col-md-3 col-xs-12">
                                                                    <Label>Select start date</Label>
                                                                    <DatePicker
                                                                        dateFormat="dd-MM-yyyy"
                                                                        selected={Date.parse(this.state.startDate)}
                                                                        onChange={this.handleFromChange}
                                                                    />
                                                                </div>
                                                                <div className="col-sm-6 col-md-3 col-xs-12">
                                                                    <Label>Select end date</Label>
                                                                    <DatePicker
                                                                        dateFormat="dd-MM-yyyy"
                                                                        selected={Date.parse(end_date2)}
                                                                        onChange={this.handleToChange}
                                                                    />
                                                                </div>
                                                                {/* <div className="col-sm-6 col-md-3 col-xs-12 top-margin-20">
                                                                    <Checkbox number={"freeemi_wallet"} label={"FreeEMI wallet?"} onChange={this.updateFreeEmiWallet.bind(this)} checked={!!(this.state.freeemi_wallet)} />
                                                                </div> */}
                                                                {/* <div className="col-sm-6 col-md-4    col-xs-12">
                                                                <Label>Maximum cashback allowed per card</Label>
                                                                <Input id="txn_value" className="maxheighter" value={this.state.maxTxnAmount} onChange={(e)=> {
                                                                    let {maxTxnAmount1} = this.state;
                                                                    maxTxnAmount1 = e.target.value;
                                                                    if(((e.target.value)*1) <= 0 || (e.target.value === '')){
                                                                        this.handleNotificationClick("tr", 3, "Insert value greater than 0");
                                                                    }
                                                                    this.setState({
                                                                        maxTxnAmount: maxTxnAmount1,
                                                                        mapField2: false
                                                                    })
                                                                }}/>
                                                                </div> */}
                                                            </div>
                                                            <br/>
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <button onClick={this.openSectionToProduct.bind(this, true)} className="btn btn-primary btn-capitalize pull-right">Save</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </TabPanel>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}
export default AdminEditPromotion;